export const POST_EVENTS = {
  DROPDOWN_SCHEDULE: "clicked-post-dropdown-schedule",
  DROPDOWN_QUEUE: "clicked-post-dropdown-queue",
  DROPDOWN_DELETE: "clicked-post-dropdown-delete",
  DROPDOWN_DELETE_QUEUE: "clicked-post-dropdown-delete-from-queue",
  DROPDOWN_DRAFT: "clicked-post-dropdown-draft",
};
